export const ContractStatus = {
    UnknownMain: "成約報告",
    UnknownDescription: "データ未作成へのアクセスです",

    InProgressMain: "成約報告",
    InProgressDescription: "承認されたデータへのアクセスです",

};

export const ContractCreate = {
    CreatedMain: "成約報告",
    CreatedDescription: "作成済みです",
}


// WEBPACK FOOTER //
// ./src/config/view_const/contract.ts